export default "__VITE_ASSET__76bd7de2__"